import { render, staticRenderFns } from "./commercialGradeList.vue?vue&type=template&id=60d02b0f&scoped=true"
import script from "./commercialGradeList.vue?vue&type=script&lang=js"
export * from "./commercialGradeList.vue?vue&type=script&lang=js"
import style0 from "./commercialGradeList.vue?vue&type=style&index=0&id=60d02b0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d02b0f",
  null
  
)

export default component.exports